import { IDaysAvailability } from './Availability.domain';
import { TMeta } from './Meta.domain';

export enum ETripView {
    BROWSE_BY_ACTIVITY = 'Browse by activity',
    MOBILE_ACTIVITY = 'Activity',
    CALENDAR = 'Calendar',
    SEARCH_DATE = 'Search date',
}

export enum ECalendarView {
    ACTIVITIES = 'Activities',
    TIME = 'Time',
}

export enum EActivityCategories {
    DOLPHIN = 'Dolphin',
    SUNSET = 'Sunset',
    BOAT = 'Boat',
    TOURIST = 'Tourist',
    PARASAILING = 'Parasailing',
    PONTOON = 'Pontoon',
    KAYAK = 'Kayak',
    BOARD = 'Board',
    SAIL = 'Sail',
    JET = 'Jet',
    FISH = 'Fish',
    WAVE = 'Wave',
}

export enum EPassengerOptions {
    'one' = '1',
    'two' = '2',
    'three' = '3',
    'four' = '4',
}

export enum EProtectionPlanOptions {
    'plan one' = '1',
    'plan two' = '2',
    'plan three' = '3',
    'plan four' = '4',
}

export enum EBoaterTestOptions {
    'test one' = '1',
    'test two' = '2',
    'test three' = '3',
    'test four' = '4',
}

export enum ETipAmount {
    TEN_PERCENT = '10%',
    FIFTEEN_PERCENT = '15%',
    EIGHTEEN_PERCENT = '18%',
    NONE = 'none',
    CUSTOM = 'custom',
}

export enum EDrawerAfterConfirmAction {
    CLOSE_DRAWER = 'closeDrawer',
    GO_BACK = 'goBack',
    SWITCH_DATE = 'switchDate',
}

export type TActivity = {
    id: string;
    name: string;
    description: string;
    description_clean: string;
    agreement: string;
    min_price: string;
    duration: string;
    rate: string;
    rate_count: string;
    images_order: number[];
    statuses: TStatuses;
    days_availability?: IDaysAvailability;
    use_calendar: boolean;
    use_schedule: boolean;
    has_overnights?: boolean;
};

export type TActivityDetails = {
    description: string;
    description_clean: string;
    duration: string;
    id: string;
    slug: string;
    image: string;
    video: string;
    min_price: number;
    name: string;
    days_availability?: IDaysAvailability;
    departure: string;
    disabled: boolean;
    agreement: string;
    address: string;
    address_details: string;
    latitude: string;
    longitude: string;
    rate: string;
    rate_count: string;
    images_order: string[];
    use_calendar: boolean;
    use_schedule: boolean;
    need_ticket_names: boolean;
    statuses: TStatuses;
    booking_tax: number;
    booking_fee: number;
    has_overnights?: boolean;
};

export type TStatuses = {
    general: string[];
    calendar: string[];
    daily: TDailyStatus[];
};

export type TDailyStatus = {
    date_from: string;
    date_to: string;
    text: string;
};

export type TActivitiesByPartner = TActivity[];

export type TTicketNames = {
    [ticket_id: string]: {
        [guest_id: string]: {
            first_name: string;
            last_name: string;
        };
    };
};
export interface IRatingStars {
    full: number;
    half: number;
}

export interface Review {
    content: string;
    id: string;
    link: string;
    rate: string;
    title: string;
}

export interface SearchRank {
    be: number;
    ms: number;
    total: number;
}

export interface SpecialStatus {
    desktop: string;
    mobile: string;
}

export type TActivityItem = {
    id: string;
    data: string;
    is_integrated: string;
    product_type_id: string;
    is_approved: string;
    is_top_offer: string;
    use_schedule: string;
    use_inventory: string;
    use_rates: string;
    disable_booking: string;
    is_disabled_online: string;
    is_disabled_ts: string;
    is_delayed: string;
    no_rwg: string;
    autoconfirm_orders: string;
    wr_affiliate: string;
    name: string;
    slug: string;
    address: string;
    google_title: string;
    latitude: string;
    longitude: string;
    affiliate_id: string;
    partner_id: string;
    sub_partner_id: string;
    valid_from: Date;
    valid_to: Date;
    updated_at: Date;
    date_created: Date;
    cut_off: string;
    cut_off_time: string;
    start_time: string;
    duration: string;
    videos: string[];
    close_out: string;
    weekly: { [key: string]: string };
    monthly: string;
    yearly: string;
    disabled: string;
    use_calendar: string;
    type_id: string;
    city_id: string;
    rating: string;
    rate_count: string;
    comment_count: string;
    photo_count: string;
    video_count: string;
    special: string;
    policy_id: string;
    use_tripflex: string;
    agreement_rs: string;
    phone: string;
    cnt_view: string;
    product_code: string;
    tax: string;
    booking_fee: null;
    comission: null;
    apply_fee_to_rwg: string;
    rs_booking_fee: null;
    show_tax: string;
    related_products: string;
    stars: string;
    search: string;
    search_important: string;
    need_tickets_guests: string;
    schedule_select_type: string;
    ticket_select_type: string;
    pandemic_meta_data: string[];
    trip_noun: string;
    trip_noun_plural: string;
    special_status: SpecialStatus;
    recent_purchased: string;
    total_purchased: string;
    title: string;
    partner_slug: string;
    partner_address: string;
    partner_comission: string;
    trip_comission: null;
    city_name: string;
    time_zone: string;
    policy_content: string;
    policy_title: string;
    price: number;
    price_strike_out: null;
    price_subunits: number;
    price_strike_out_subunits: null;
    url: string;
    url_search: string;
    previewDescription: string;
    is_active: number;
    locations: Location[];
    tags: string[];
    reviews: Review[];
    rating_stars: IRatingStars;
};

export type TActivityById = {
    meta: TMeta;
    items: TActivityItem[];
    activity_ids: string;
};

export type TTripSettingsFormik = {
    passenger_count: EPassengerOptions | undefined;
    protection_plan: EProtectionPlanOptions | undefined;
    boater_test: EBoaterTestOptions | undefined;
    tip_amount: ETipAmount | undefined;
    comment: string;
};

export type TTripSettingsForm = TTripSettingsFormik;
